import React, { useEffect } from "react";
import { ReactNode, useState } from "react";
import { createContext } from "react";
import { toastError, toastSuccess, toastWarn } from "../../../components/Toast";
import useAuthData from "../../../hook/useAppData";
import { dateMonthAndYear, splitFormartDate } from "../../../libs/dateUtils";
import { orderBy } from "../../../libs/orderBy";
import { orderByName } from "../../../libs/orderList";
import { serviceUsers } from "../../Collaborator/service";
import { service } from "../../Project/service/service";
import { orderByFieldEditableGeneration, orderByFieldGeneration } from "../lib";
import { ApprovalHoursContextProps, IGetApproveHours, TimePointProjectUsers } from "../model";
import { getAllTimeWorkList, getTimeWorkDownload, postTimeWorkApproved } from "../service";
import { columns } from "./constant";

interface ApprovalHoursProviderProps {
  children: ReactNode;
}

const orderByField = orderByFieldGeneration(columns);
const orderByFieldEditable = orderByFieldEditableGeneration(columns);

export const ApprovalHoursContext = createContext({} as ApprovalHoursContextProps);

export function ApprovalHoursProvider({ children }: ApprovalHoursProviderProps) {
  const { token } = useAuthData();

  const [rows, setRows] = useState([] as TimePointProjectUsers[]);
  const [selectProject, setSelectProject] = useState(false);

  const [page, setPage] = useState(0);
  const [selectSize, setSelectSize] = useState(10);

  const [monthAndYear, setMonthAndYear] = useState(dateMonthAndYear);

  const [listProject, setListProject] = useState([] as any);
  const [listUsers, setListUsers] = useState([]);
  const [emptyFilter, setEmptyFilter] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);

  const [csv, setCsv] = useState();
  const [csvStatus, setCsvStatus] = useState(false);

  const [needSpinner, setNeedSpinner] = useState(true);
  const [orderSwitch, setOrderSwitch] = useState(true);

  const [contractType, setContractType] = useState();
  const [state, setState] = useState(false);
  const [listRender, setListRender] = useState([] as TimePointProjectUsers[]);
  const [listExceeded, setListExceeded] = useState<TimePointProjectUsers[]>();
  const [listBelow, setListBelow] = useState<TimePointProjectUsers[]>();
  const [listNormal, setListNormal] = useState<TimePointProjectUsers[]>();
  const [listGroupped, setListGroupped] = useState<TimePointProjectUsers[]>();
  const [optionListSelected, setOptionListSelected] = useState(4);
  const [modalFilters, setModalFilters] = useState(false);
  // const [warnNotCalled, setWarnNotCalled] = useState(false);
  const lists = [
    { list: listExceeded, name: "Acima do normal" },
    { list: listBelow, name: "Abaixo do normal" },
    { list: listNormal, name: "Normal" },
    { list: listGroupped, name: "Todos" },
  ];

  useEffect(() => {
    getComponet();
    getProject();
    getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setNeedSpinner(false);
    }, 500);
  }, [listRender, state, rows, orderSwitch]);

  useEffect(() => {
    setNeedSpinner(true);
    alterListRender(lists[+optionListSelected - 1].list);
  }, [listExceeded, listBelow, listNormal, listGroupped, optionListSelected, rows, state]);

  function alterListRender(list: TimePointProjectUsers[]) {
    let arrRender = [];
    list?.forEach((row: TimePointProjectUsers) => {
      if (row?.contractType === "PJ" && !state) arrRender.push(row);
      if (row?.contractType === "CLT" && state) arrRender.push(row);
    });
    setListRender(arrRender);
  }

  async function getComponet() {
    const splitYearAndMonth = splitFormartDate(monthAndYear);
    await Promise.all([handleExportCSV(splitYearAndMonth), getFilterAllTotalWorkList(token, splitYearAndMonth)]);
  }

  async function handleExportCSV(splitYearAndMonth: any, userId?: number, projectId?: number) {
    setCsvStatus(false);
    const data = await getTimeWorkDownload(token, splitYearAndMonth[0], splitYearAndMonth[1], userId, projectId);
    try {
      if (!data?.length) return;
      setCsv(data);
      setCsvStatus(true);
    } catch (error) {
      console.error(error);
      toastError("Erro!");
    }
  }

  async function getFilterAllTotalWorkList(token: string, splitYearAndMonth: any) {
    const data: IGetApproveHours = await getAllTimeWorkList(token, splitYearAndMonth[0], splitYearAndMonth[1]);
    try {
      notFoundList(data?.userListExceeded);
      const listExceededOrder = orderByName(data?.userListExceeded, "userName");
      setListExceeded(listExceededOrder);
      const listBelowOrder = orderByName(data?.userListBelow, "userName");
      setListBelow(listBelowOrder);
      const listNormalOrder = orderByName(data?.userListNormal, "userName");
      setListNormal(listNormalOrder);
      groupeList(data);
    } catch {
      console.log(data);
      toastError("Erro!");
    }
  }

  function groupeList(data: IGetApproveHours) {
    let listExceededOfConcat = data?.userListExceeded;
    const listFinal = listExceededOfConcat.concat(data?.userListBelow)?.concat(data?.userListNormal);
    const listFinalOrder = orderByName(listFinal, "userName");
    setListGroupped(listFinalOrder);
  }

  function handleOrderList(label: string) {
    orderSwitch ? setListRender(orderBy(listRender, label, "desc")) : setListRender(orderBy(listRender, label, "asc"));
    setOrderSwitch((oldState) => !oldState);
    setNeedSpinner(true);
    setPage(0);
  }

  async function getProject() {
    const data = await service.getProjects(token);
    try {
      const orderData = orderByName(data, "name");
      setListProject(orderData);
    } catch (error) {
      console.error(error);
      toastError("Erro!");
    }
  }

  async function getUsers() {
    const data = await serviceUsers.getUsers(token);
    try {
      const orderData = orderByName(data, "name");
      setListUsers(orderData);
    } catch (error) {
      console.error(error);
      toastError("Erro!");
    }
  }

  async function handleSaveApi(value: any) {
    const timesWorksApproved = {
      timesWorksApproved: value,
    };

    const data = await postTimeWorkApproved(token, timesWorksApproved);
    toastSuccess("Sucesso na consolidação das horas!");
    if (data?.ok) {
      setNeedSpinner(true);
      await getComponet();
      return;
    }
    toastError("Erro na hora de consolidar!");
  }

  function notFoundList(data: any) {
    if (!data?.length) return setEmptyFilter(true);
    return setEmptyFilter(false);
  }

  return (
    <ApprovalHoursContext.Provider
      value={{
        rows,
        modalStatus,
        setModalStatus,
        handleSaveApi,
        getComponet,
        listUsers,
        listProject,
        monthAndYear,
        setMonthAndYear,
        setSelectProject,
        setRows,
        handleExportCSV,
        notFoundList,
        getFilterAllTotalWorkList,
        setNeedSpinner,
        csv,
        csvStatus,
        columns,
        page,
        setPage,
        selectSize,
        setSelectSize,
        needSpinner,
        orderByField,
        orderByFieldEditable,
        handleOrderList,
        contractType,
        listRender,
        setListRender,
        state,
        setState,
        modalFilters,
        setModalFilters,
        optionListSelected,
        setOptionListSelected,
        setListExceeded,
        setListBelow,
        setListNormal,
        groupeList,
      }}
    >
      {children}
    </ApprovalHoursContext.Provider>
  );
}
